<template>
  <div v-if="showModal" class="side__modal opened">
    <div class="side__modal__content">
      <div class="modal__top">
        <div class="modal__header">
          <h3 class="modal__title">{{ $lang.app.SELECT_AGREEDS }}</h3>
          <span class="modal__close" @click="closeModal">
          <svg viewBox="0 0 20 20" width="20" height="20"><use xlink:href="@/assets/v2/img/sprite.svg#modal__close"></use></svg></span>
        </div>
      </div>

      <Form class="modal__footer"
            @submit="submit">

        <div class="input__group input__add__info">
          <label for="state-input" class="label">{{ $lang.app.SUBDIVISION }}</label>
          <div class="select__wrapper">
            <Field name="state" v-slot="{ field, errorMessage }">
              <Multiselect
                  id="state-input"
                  :class="{'select--fail': errorMessage }"
                  v-bind="field"
                  v-model="state"
                  :options="helper.stateOptions"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
                  :can-clear="false">
              </Multiselect>
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>
        </div>

        <div class="input__group input__add__info">
          <label for="department-input" class="label">{{ $lang.app.DEPARTMENT }}</label>
          <div class="select__wrapper">
            <Field name="department" v-slot="{ field, errorMessage }">
              <Multiselect
                  id="department-input"
                  :class="{'select--fail': errorMessage }"
                  v-bind="field"
                  v-model="department"
                  :options="helper.departmentOptions"
                  :placeholder="$lang.app.SELECT_FROM_OPTIONS"
                  :searchable="true"
                  :noOptionsText="$lang.app.LIST_EMPTY"
                  :noResultsText="$lang.app.NOT_FOUND"
                  :can-clear="false">
              </Multiselect>
              <span v-if="errorMessage" class="input__fail">{{ errorMessage }}</span>
            </Field>
          </div>
        </div>

        <AgreedsMultiselect
            :value="form.employees"
            @update="form.employees = $event"
            :with-accountant="withAccountant"
            :options="helper.employeeOptions"/>

        <div class="between__buttons">
          <button type="button" class="button button__modal__close button--cancel"
                  @click="closeModal">{{ $lang.app.CANCEL }}</button>
          <button type="submit" class="button button__modal__close">{{ this.$lang.app.SAVE }}</button>
        </div>
      </Form>
    </div>
  </div>
</template>
<script>
import {Field, Form} from 'vee-validate';

import stateApi from "../../../../../api/ref/state";
import departmentApi from "../../../../../api/employee/department";
import employeeApi from "../../../../../api/employee/employee";
import AgreedsMultiselect from "../../inputs/AgreedsMultiselect";
import {getValueByKey as executorTypesGetValue} from "../../../../../helpers/constants/executorTypes";

export default {
  components: {
    Field,
    Form,
    AgreedsMultiselect
  },
  data() {
    return {
      showModal: false,
      agreeds: [],
      withAccountant: null,

      state: null,
      department: null,
      form: {employees: []},
      helper: {
        stateOptions: [],
        departmentOptions: [],
        employeeOptions: [],
      },
    };
  },
  watch: {
    agreeds: {
      handler: function (val) {
        this.form.employees = val.map(e => ({...e}))
      },
      deep: true
    },
    'state'(value) {
      if (value) {
        this.department = null
        this.setDepartmentOptions(value)
      }
    },
    'department'(value) {
      this.helper.employeeOptions = []
      if (value) {
        employeeApi.getEmployeesByDepartmentId(value).then((res) => {
          this.helper.employeeOptions = res.data?.map((item) => ({
            id: item.id,
            name: item.fullName,
            position: this.$lang.$translate({ru: item.position.nameRu, kg: item.position.nameKg}),
            type: this.executorTypesGetValue('SIGNER'),
            vacation: item.activeVacation,
          }));
        });
      }
    }
  },
  methods: {
    openModal() {
      this.showModal = true
      this.$emitter.emit('body-unscrollable')
    },
    closeModal() {
      this.showModal = false
      this.$emitter.emit('body-scrollable')
    },
    executorTypesGetValue,
    initStateOptions() {
      stateApi.getSubStates().then((res) => {
        this.helper.stateOptions = res.map(stateItem => ({
          value: stateItem.id,
          label: this.$lang.$translate({ru: stateItem.nameRu, kg: stateItem.nameKg}),
        }))
      })
    },
    setDepartmentOptions(value) {
      departmentApi.getActiveDepartmentsByStateId(value).then((res) => {
        this.helper.departmentOptions = res.map(departmentItem => ({
          value: departmentItem.id,
          label: this.$lang.$translate({ru: departmentItem.nameRu, kg: departmentItem.nameKg}),
        }))
      })
    },
    valid() {
      if(!this.form.employees.some(e => e.type === this.executorTypesGetValue('CLOSING_SIGNER'))) {
        this.$snotify.error(this.$lang.app.ASSIGN_CLOSING_SIGNER)
        return false
      }
      if(this.withAccountant && !this.form.employees.some(e => e.type === this.executorTypesGetValue('ACCOUNTANT'))) {
        this.$snotify.error(this.$lang.app.ASSIGN_ACCOUNTANT)
        return false
      }
      return true
    },
    submit() {
      if(this.valid()) {
        this.$emitter.emit('agreeds-selected', this.form.employees)
        this.closeModal()
      }
    },
  },
  beforeMount() {
    this.$emitter.on('open-select-agreeds-modal', (payload) => {
      this.agreeds = payload.agreeds
      this.withAccountant = payload.withAccountant
      this.form = {
        employees: this.agreeds.map(e => ({...e})),
      }
      this.openModal()
      this.initStateOptions()
    })
    this.$emitter.on('select-agreeds-changed', (agreeds) => {
      this.agreeds = agreeds
    })
  },
  beforeUnmount() {
    this.$emitter.off('open-select-agreeds-modal')
    this.$emitter.off('select-agreeds-changed')
  }
}
</script>
